import {StatusBadge, StatusBadgeProps} from '@/components/app/feedback';
import {cn} from '@/lib/utils';
import {getConditionTypeColorByName} from '../utils';
export interface ConditionTypeTagProps extends StatusBadgeProps {
  conditionTypeName: string;
  outlined?: boolean;
}
export const ConditionTypeTag = ({
  className,
  conditionTypeName,
  outlined,
  children,
  ...otherProps
}: ConditionTypeTagProps) => {
  const conditionTypeColor = getConditionTypeColorByName(conditionTypeName);
  return (
    <StatusBadge
      {...otherProps}
      className={cn(className, {
        [`bg-${conditionTypeColor} text-${conditionTypeColor}-foreground`]: !outlined,
        [`border-${conditionTypeColor}   border   text-${conditionTypeColor} bg-transparent`]: outlined,
      })}
    >
      {children ?? conditionTypeName}
    </StatusBadge>
  );
};
